module.exports = __webpack_public_path__ + "img/notice-background-header.0beb1c7.png";